var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.774 7.24121C23.7442 7.24121 19.8795 8.84202 17.0301 11.6915C14.1806 14.5409 12.5798 18.4056 12.5798 22.4354V30.5423L9.32489 38.6932C9.22294 38.9491 9.1852 39.2262 9.21495 39.5001C9.2447 39.774 9.34104 40.0365 9.49556 40.2646C9.65009 40.4927 9.8581 40.6796 10.1014 40.8088C10.3448 40.938 10.616 41.0058 10.8916 41.006H44.6564C44.9319 41.0058 45.2032 40.938 45.4465 40.8088C45.6899 40.6796 45.8979 40.4927 46.0524 40.2646C46.2069 40.0365 46.3033 39.774 46.333 39.5001C46.3628 39.2262 46.325 38.9491 46.2231 38.6932L42.9682 30.5389V22.4354C42.9682 18.4056 41.3674 14.5409 38.5179 11.6915C35.6684 8.84202 31.8037 7.24121 27.774 7.24121ZM27.774 49.4473C26.2766 49.4476 24.8215 48.9503 23.6376 48.0335C22.4537 47.1167 21.6081 45.8324 21.2337 44.3825H34.3142C33.9399 45.8324 33.0943 47.1167 31.9104 48.0335C30.7264 48.9503 29.2714 49.4476 27.774 49.4473Z",
    fill: "#FF7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notifIcon.05f204577a477cf24b97574be30369e2.svg";
export { ForwardRef as ReactComponent };